import ProfilesModel, { ProfileFilters, ProfileForm } from "../models/profiles.model";
import { ProfileType } from "../types/profile";
import { useReducerAsState } from "./useReducerAsState"

interface State {
    loading: boolean;
    profiles: Array<ProfileType>;
    profile: ProfileType | null;
    error: string;
    totalProfiles: number;
}

const useProfiles = () => {
    const [state, setState ] = useReducerAsState<State>({
        loading: false,
        profiles: [],
        error: "",
        totalProfiles: 0,
        profile: null
    })

    const { profile, profiles, totalProfiles, loading, error} = state
 
    const fetchProfiles = async (filters: ProfileFilters) => {
        setState({ loading: true, error:"" })
        const response = await ProfilesModel.getAll(filters);
        if(response.error){
            setState({ loading: false, error: response.error, profiles: [], totalProfiles: 0 });
            return
        }

        setState({ loading: false, error: "", profiles: response.profiles?.data, totalProfiles: response.total });
    }

    const createProfile = async (data: ProfileForm) => {
        setState({ loading: true, error: "" })
        const response = await ProfilesModel.create(data)
        if(response.error){
            setState({ error: response.error, loading: false })
            return false
        }

        setState({ error: "", loading: false})
        return true
    }

    const updateProfile = async (id: number, data: ProfileForm) => {
        setState({ loading: true, error: "" })
        const response = await ProfilesModel.update(id, data)
        if(response.error){
            setState({ error: response.error, loading: false })
            return false
        }

        setState({ error: "", loading: false})
        return true
    }

    const getProfile = async (id: number) => {
        setState({ loading: true, error: "", profile: null })
        const response = await ProfilesModel.find(id)
        if(response.error){
            setState({ error: response.error, loading: false, profile: null })
            return
        }

        setState({ error: "", loading: false, profile: response.profiles?.data[0]})
    }

    return {
        loading, 
        profile,
        profiles,
        totalProfiles,
        fetchProfiles,
        createProfile,
        updateProfile,
        getProfile,
        error
    }
}

export default useProfiles